<template>
  <div>
    <Table v-if="showTable" ref="projMthRptCard" :width="(110 * Math.min(projMthRptDDList.length, 3)) + 220 + 20" size="small"
           :columns="transColumns" :data="list" border :show-header="false">
      <template slot-scope="{ row, index }" slot="col_0" v-if="projMthRptDDList.length > 0">
        <template v-if="index === 0">
          <a href="javascript:void(0)" @click="gotoRptList(row.col_0)">{{ rptMthMap[row.col_0] }}</a>
        </template>
        <template v-else-if="index === 1">
          <Tag :color="rptStatusColor[row.col_0]">
            {{ Utils.formatI18nValue($t, 'common.commonVar.rptStatus.', row.col_0) }}
          </Tag>
        </template>
      </template>

      <template slot-scope="{ row, index }" slot="col_1" v-if="projMthRptDDList.length > 1">
        <template v-if="index === 0">
          <a href="javascript:void(0)" @click="gotoRptList(row.col_1)">{{ rptMthMap[row.col_1] }}</a>
        </template>
        <template v-else-if="index === 1">
          <Tag :color="rptStatusColor[row.col_1]">
            {{ Utils.formatI18nValue($t, 'common.commonVar.rptStatus.', row.col_1) }}
          </Tag>
        </template>
      </template>

      <template slot-scope="{ row, index }" slot="col_2" v-if="projMthRptDDList.length > 2">
        <template v-if="index === 0">
          <a href="javascript:void(0)" @click="gotoRptList(row.col_2)">{{ rptMthMap[row.col_2] }}</a>
        </template>
        <template v-else-if="index === 1">
          <Tag :color="rptStatusColor[row.col_2]">
            {{ Utils.formatI18nValue($t, 'common.commonVar.rptStatus.', row.col_2) }}
          </Tag>
        </template>
      </template>

      <template slot-scope="{ row, index }" slot="more">
        <template v-if="index === 0">
          <a href="javascript:void(0)" @click="gotoRptList('more')">{{ row.more }}</a>
        </template>
      </template>
    </Table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as Utils from '@/utils'
import SearchWrapper from '@/components/wrapper/SearchWrapper'

export default {
  components: {
    // Title
    SearchWrapper
  },
  props: {
    compId: {
      type: String,
      require: true,
      default: () => {
        return ''
      }
    },
    projId: {
      type: String,
      require: true,
      default: () => {
        return ''
      }
    // },
    // projMthRptDDList: {
    //   type: Array,
    //   require: false,
    //   default: () => {
    //     return []
    //   }
    }
  },
  data() {
    return {
      Utils: Utils,
      list: [],
      rptMthMap: {},
      pStyle: {
        fontSize: '16px',
        color: 'rgba(0,0,0,0.85)',
        lineHeight: '24px',
        display: 'block',
        marginBottom: '16px'
      },
      showTable: false,
      END_DATA: null
    }
  },
  computed: {
    ...mapState('projMthRptManage', [
      'projMthRptDDList'
    ]),
    transColumns() {
      const columns = []
      columns.push(
        {
          // title: this.$t('module.proj.projsettletrans.info.transDt'),
          key: 'month',
          align: 'center',
          width: 110
        }
      )

      if (this.projMthRptDDList.length > 0) {
        columns.push(
          {
            // title: this.$t('module.proj.projsettletrans.info.transDt'),
            slot: 'col_0',
            align: 'center',
            width: 110
          }
        )
      }

      if (this.projMthRptDDList.length > 1) {
        columns.push(
          {
            // title: this.$t('module.proj.projsettletrans.info.transDt'),
            slot: 'col_1',
            align: 'center',
            width: 110
          }
        )
      }

      if (this.projMthRptDDList.length > 2) {
        columns.push(
          {
            // title: this.$t('module.proj.projsettletrans.info.transDt'),
            slot: 'col_2',
            align: 'center',
            width: 110
          }
        )
      }

      columns.push(
        {
          // title: this.$t('module.proj.projsettletrans.info.transDt'),
          slot: 'more',
          align: 'center',
          minWidth: 110
        }
      )

      return columns
    },
    rptStatusColor() {
      return this.$store.state.rptStatusColor
    },
    END_COMPUTED() {
      return null
    }
  },
  methods: {
    gotoRptList(rptId) {
      // debugger
      if (rptId !== 'more') {
        this.$router.push({path: '/proj/rpt/entryProjMthRptDetail', query: {rptId, projId: this.projId, compId: this.compId, menuKey: 'RspProjectHomePage'}})
      } else {
        this.$router.push({path: '/proj/rpt/entryProjMthRptList', query: {projId: this.projId, compId: this.compId, menuKey: 'RspProjectHomePage'}})
      }
    },
    findProjMthRptDDList() {
      // if (this.authedFnKeyMap.FTC8TY) {
      this.$store.dispatch('projMthRptManage/findProjMthRptDDList', {projId: this.projId, compId: this.compId, ...Utils.getCodeParam(this.$route)})
        .then(res => {
          this.showProjMthRptCard()
        })
      // }
    },
    showProjMthRptCard() {
      // debugger
      const list = [
        {
          month: this.$t('module.proj.rpt.projmthrpt.info.rptMth'),
          more: this.$t('common.commonVar.more')
        },
        {
          month: this.$t('module.proj.rpt.projmthrpt.info.rptStatus'),
          more: ''
        }
      ]
      const rptMthMap = {}
      for (let i = 0; i < this.projMthRptDDList.length && i < 3; i++) {
        rptMthMap[this.projMthRptDDList[i].rptId] = this.projMthRptDDList[i].rptMth
        list[0]['col_' + i] = this.projMthRptDDList[i].rptId
        list[1]['col_' + i] = this.projMthRptDDList[i].rptStatus
      }
      this.list = list
      this.rptMthMap = rptMthMap
      Utils.nextTick(this, 'showTable', true)
    },
    END_METHODS() {}
  },
  async mounted() {
    // debugger
    this.findProjMthRptDDList()
  },
  async destroyed() {
    // debugger
    // this.cleanForm()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/proj/ProjMthRptCard.vue